import gql from 'graphql-tag'
import client from '../../stores/apollo'
import { IFloorMap } from '../types'
import { FloorMapFragment } from '../fragments'

interface IPayload {
  data: {
    map: IFloorMap
  }
}

export default function map(id: string): Promise<IFloorMap> {
  const variables = { id }

  return client.gql.query({ query, variables }).then(({ data: { map } }: IPayload) => map)
}

const query = gql`
  query FloorMap($id: ID!) {
    map: node(id: $id) {
      ...FloorMapFragment
    }
  }
  ${FloorMapFragment}
`
